import { useContext, useState } from "react";
import {
  useCreatePOCategoryMutation,
  useUpdatePOCategoryMutation,
} from "../../../../hooks/api/mutations";
import { ToastContext } from "../../../../hooks/context";

export const usePOCategoriesForm = ({
  isEditMode = false,
  pOCategoryDetails = {},
  closeModal = () => {},
}) => {
  const triggerToast = useContext(ToastContext);
  const [formData, setFormData] = useState({
    name: pOCategoryDetails?.name || "",
    description: pOCategoryDetails?.description || "",
  });

  const { mutate: createCategory, isLoading: isCreating } =
    useCreatePOCategoryMutation();

  const { mutate: updateCategory, isLoading: isUpdating } =
    useUpdatePOCategoryMutation({ id: pOCategoryDetails?.id });

  const handleCreateCetgory = () => {
    createCategory(formData, {
      onSuccess: () => {
        triggerToast("Procurement category creation successful", "success");
        closeModal();
      },
    });
  };

  const handleUpdateCetgory = () => {
    updateCategory(
      { id: pOCategoryDetails?.id, data: { ...formData } },
      {
        onSuccess: () => {
          triggerToast("Procurement category updated successfully", "success");
          closeModal();
        },
      },
    );
  };

  const handleCreateOrUpdateCategory = () => {
    if (isEditMode) handleUpdateCetgory();
    else handleCreateCetgory();
  };

  return {
    isLoading: isCreating || isUpdating,
    formData,
    setFormData,
    handleCreateOrUpdateCategory,
  };
};
